import React, { useContext, useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Grid,
  Box,
  styled,
} from "@mui/material";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import AddCustomer from "./AddCustomer";
import UploadDoc from "./UploadDoc";
import { ConnContext } from "../../store/ConnContext";
import { useSelector } from "react-redux";
import { axiosGetApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import AddCompanyImage from "../../../assets/Images/image 76.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import { Person, CloudUpload } from "@mui/icons-material";

// ✅ Custom Connector for step line
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor: "#F97316",
    borderRadius: 1,
  },
}));

// ✅ Custom step number icon
const NumberStepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor:
    ownerState.active || ownerState.completed ? "#F97316" : "#E0E0E0", // orange for active/completed, gray for inactive
  color: ownerState.active || ownerState.completed ? "#FFFFFF" : "#9E9E9E", // white icon for active, gray for inactive
  width: 42,
  height: 42,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  fontSize: "18px",
  transition: "all 0.3s ease",
}));

function NumberStepIcon(props) {
  const { active, completed, icon } = props;

  const icons = {
    1: <Person fontSize="small" />,
    2: <CloudUpload fontSize="small" />,
  };

  return (
    <NumberStepIconRoot ownerState={{ active, completed }}>
      {icons[String(icon)]}
    </NumberStepIconRoot>
  );
}

// ✅ Stepper step labels
const stepperList = [
  {
    step: "Step 1",
    name: "Information",
  },
  {
    step: "Step 2",
    name: "Upload Documents",
  },
];

// ✅ Main component

const initialDocuments = [
  {
    id: 1,
    name: "GST Certificate",
    uploaded: false,
    editDataKey: "gstCertificateFilePath",
  },
  // {
  //   id: 2,
  //   name: "Retailer Incorporation Certificate",
  //   uploaded: false,
  //   editDataKey: "incorporationCertificateFilePath",
  // },
  {
    id: 2,
    name: "Aadhar Front Copy",
    uploaded: false,
    editDataKey: "aadharFrontFilePath",
  },
  {
    id: 3,
    name: "Aadhar Back Copy",
    uploaded: false,
    editDataKey: "aadharBackFilePath",
  },
  {
    id: 4,
    name: "LMBP PAN Card",
    uploaded: false,
    editDataKey: "panTanFilePath",
  },
  // {
  //   id: 6,
  //   name: "Authorized Person PAN Card",
  //   uploaded: false,
  //   editDataKey: "authPersonPanFilePath",
  // },
  // {
  //   id: 7,
  //   name: "Board Resolution",
  //   uploaded: false,
  //   editDataKey: "boardResolutionFilePath",
  // },
];

const AddCustomerTabs = ({
  CloseCreate,
  show,
  editData,
  action,
  fetchCustomerData,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [documents, setDocuments] = useState(initialDocuments);
  const [hubList, setHubList] = useState([]);
  const [isHubLoaded, setIsHubLoaded] = useState(false);

  const { payloadData, setPayloadData } = useContext(ConnContext);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (action === "add") {
      // Reset form data for adding a new customer
      setPayloadData({
        username: loggedInUserName,
        name: "",
        emailId: "",
        address1: "",
        address2: "",
        address3: "",
        city: "",
        state: "",
        pinCode: "",
        firstContactPersonName: "",
        firstContactPersonMobileNo: "",
        bankName: "",
        accountNo: "",
        ifscCode: "",
        gstNumber: "",
        aadharNumber: "",
        panNumber: "",
        companyPanNumber: "",
        companyType: "",
        hubCode:"",
        hubName:"",
        lmbpBusinessType:"",
        isEcommerce:"",
        masterLmbpCode: "",
        hierarchyType: "",
        parentType: "",
      });
    } else if (
      action === "modify" ||
      action === "view" ||
      action === "delete" ||
      action === "auth"
    ) {
      // Pre-fill the form with editData
      setPayloadData({
        ...editData,
        username: loggedInUserName,
        state: editData?.state || "",
        city: editData?.city || "",
        bankName: editData?.bankName || "",
        isEcommerce: editData?.isEcommerceE,
      });
    }
  }, [action, editData]);

  const loggedInUserName = user?.data?.username;

  const handleHubNameList = async () => {
     // 🔒 prevent multiple calls
     if (isHubLoaded) return;
   
     const payload = {
       username: loggedInUserName,
     };
   
     try {
       const response = await axiosGetApi(
         apiList.ALL_ACTIVE_HUB_DATA,
         payload
       );
   
       if (
         response?.data?.status === true &&
         response?.data?.respCode === "00"
       ) {
         setHubList(response?.data?.data || []);
         setIsHubLoaded(true); // ✅ mark as loaded
       }
     } catch (error) {
       CustomAlert({
         title: "Error",
         text: "An error occurred while processing.",
         icon: "error",
         confirmButtonText: "Retry",
       });
     }
  };

  const isCreateode = action === "add";
  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";

  const isValidClick = isCreateode || isEditMode;

  useEffect(() => {
   if (show && !isViewMode && !isDeleteMode && !isAuthMode) {
      handleHubNameList();
   }
}, [show]);

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleStepClick = (index) => {
    setActiveStep(index);
  };

  const getComponentByActiveStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <AddCustomer
            payloadData={payloadData}
            setPayloadData={setPayloadData}
            loggedInUserName={loggedInUserName}
            handleNext={handleNext}
            handleBack={handleBack}
            CloseCreate={CloseCreate}
            editData={editData}
            action={action}
            fetchCustomerData={fetchCustomerData}
             hubList={hubList}
          />
        );
      case 1:
        return (
          <UploadDoc
            payloadData={payloadData}
            setPayloadData={setPayloadData}
            loggedInUserName={loggedInUserName}
            CloseCreate={CloseCreate}
            editData={editData}
            action={action}
            fetchCustomerData={fetchCustomerData}
            documents={documents}
            setDocuments={setDocuments}
            initialDocuments={initialDocuments}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        style={{ display: show ? "block" : "none" }}
      >
        <div
          className="modal-dialog"
          role="document"
          style={{
            maxWidth: "60%",
            margin: "auto",
          }}
        >
          <div
            className="modal-content rounded-[20px]"
            style={{
              maxHeight: "50%",
              overflowY: "auto",
              paddingBottom: "10px",
            }}
          >
            <img
              src={LeftCircle}
              alt="leftImg"
              className="absolute left-0 bottom-0 w-[110px] h-[105px]"
            />
            <img
              src={RightCircle}
              alt="leftImg"
              className="absolute right-0 top-0 w-[110px] h-[105px]"
            />
            <div className="modal-header flex justify-between items-center border-b-0">
              <div className="flex items-center gap-3">
                <img
                  src={AddCompanyImage}
                  alt="add-company-img"
                  className="h-11 w-11"
                />
                <h5 className="modal-title main-title m-0 font-semibold">
                  {action.charAt(0).toUpperCase() + action.slice(1)} LMBP
                  Details
                </h5>
              </div>
              <img
                src={CrossIcon}
                alt="filter icon"
                className="w-[30px] h-[30px] cursor-pointer z-20"
                onClick={CloseCreate}
              />
            </div>

            <Grid item xs={12} sx={{ px: 3, pt: 2 }}>
              <div
                className="rounded-t-2xl flex justify-center items-center"
                style={{
                  backgroundColor: "#FFCCB3",
                  borderBottom: "2px solid #F97316",
                  padding: "4px 0",
                }}
              >
                <Stepper
                  activeStep={activeStep}
                  connector={<CustomConnector />}
                  sx={{
                    width: "70%",
                    "& .MuiStepLabel-root .Mui-completed": {
                      color: "#F97316",
                    },
                    "& .MuiStepLabel-root .Mui-active": {
                      color: "#F97316",
                    },
                  }}
                  alternativeLabel
                >
                  {stepperList.map((label, index) => (
                    <Step key={index}>
                      <StepLabel
                        StepIconComponent={NumberStepIcon}
                        // onClick={() => handleStepClick(index)}
                        sx={{
                          "& .MuiStepLabel-label": {
                            marginTop: "2px !important",
                          },
                        }}
                      >
                        <div
                          className={`font-poppins font-semibold text-[15px] ${
                            activeStep === index
                              ? "text-[#F97316]"
                              : "text-[#145165]"
                          }`}
                        >
                          {label.name}
                        </div>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>
            </Grid>

            <Box sx={{ p: 2 }}>{getComponentByActiveStep()}</Box>

            {/* <div className="scoped-modal modal-footer">
              <button type="button" className="btn btn-back" onClick={CloseCreate}>
                Back
              </button>
            </div> */}
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default AddCustomerTabs;
